function formatTime(totalMinutes) {

    const hours =
        Math.floor(totalMinutes / 60);

    const minutes =
        totalMinutes % 60;

    return (
        `${String(hours).padStart(2, "0")}:` +
        `${String(minutes).padStart(2, "0")}`
    );
}

export function generateTimeSlots(court) {

    if (!court) return [];

    const slots = [];

    const {
        openingTime,
        closingTime,
        slotDuration,
    } = court;

    // openingTime = "08:00"
    const [openHour, openMinute] =
        openingTime
            .split(":")
            .map(Number);

    const [closeHour, closeMinute] =
        closingTime
            .split(":")
            .map(Number);

    const openingMinutes =
        openHour * 60 + openMinute;

    const closingMinutes =
        closeHour * 60 + closeMinute;

    let currentMinutes =
        openingMinutes;

    while (
        currentMinutes + slotDuration
        <= closingMinutes
    ) {

        const endMinutes =
            currentMinutes + slotDuration;

        const startTime =
            formatTime(currentMinutes);

        const endTime =
            formatTime(endMinutes);

        slots.push({

            id:
                `${court.id}-${startTime}`,

            time:
                `${startTime} - ${endTime}`,

            // store decimal hour internally
            startHour:
                currentMinutes / 60,

            endHour:
                endMinutes / 60,

            // duration in hours
            duration:
                slotDuration / 60,

            available: true,
        });

        currentMinutes += slotDuration;
    }

    return slots;
}